import axiosInstance from "../app/axios";

export type CreateGuestTripAccessInput = {
  address?: string;
  latitude?: number;
  longitude?: number;
  countryId?: number;
  buttonText?: string;
};

export type UpdateGuestTripAccessInput = {
  buttonText?: string;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  countryId?: number | null;
};

export type GuestTripAccessCode = {
  id?: number;
  code: string;
  adminId?: number;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  countryId?: number | null;
  buttonText?: string | null;
};

export const getGuestTripAccessByToken = async (): Promise<GuestTripAccessCode | null> => {
  try {
    const result = await axiosInstance.get("guest-trip-access/by/token");
    return result.data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const createGuestTripAccessCode = async (
  input: CreateGuestTripAccessInput,
): Promise<GuestTripAccessCode> => {
  const result = await axiosInstance.post("guest-trip-access", input);
  return result.data;
};

export const updateGuestTripAccessCode = async (
  id: number,
  input: UpdateGuestTripAccessInput,
): Promise<GuestTripAccessCode> => {
  const result = await axiosInstance.patch(`guest-trip-access/${id}`, input);
  return result.data;
};

export const saveGuestTripAccessConfig = async (
  existing: GuestTripAccessCode | null | undefined,
  input: UpdateGuestTripAccessInput,
): Promise<GuestTripAccessCode> => {
  if (existing?.id) {
    return updateGuestTripAccessCode(existing.id, input);
  }

  const createInput: CreateGuestTripAccessInput = {
    countryId: input.countryId ?? undefined,
    buttonText: input.buttonText,
  };

  if (
    input.address &&
    input.latitude != null &&
    input.longitude != null
  ) {
    createInput.address = input.address;
    createInput.latitude = input.latitude;
    createInput.longitude = input.longitude;
  }

  return createGuestTripAccessCode(createInput);
};
